export type CurrentUser = {
  id: string;
  email: string;
  name?: string | null;
  role: 'ADMIN' | 'MEMBER';
};

export type CurrentOrg = {
  id: string;
  name: string;
  slug: string;
} | null;

const TOKEN_KEY = 'st_token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string | null) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export type MeResponse = {
  user: CurrentUser;
  organization: CurrentOrg;
};
